export const stepOneData = [
  {
    heading: "Why Use ICICI Bank Home Loan EMI Calculator?",
    // paras before heading

    infoList: [
      {
        heading: "Instant Results: ",
        description:
          "Get your EMI calculated in seconds with the provided information.",
      },
      {
        heading: "Clear Insights:: ",
        description:
          "Understand how loan amount, tenure, and interest rates affect your monthly payments.",
      },
      {
        heading: "Free and Easy: ",
        description:
          "The calculator is available for free and is simple to use, allowing you to plan your finances better.",
      },
      {
        heading: "Loan Comparison: ",
        description:
          "Compare multiple loan scenarios by adjusting the parameters and make the most suitable choice.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    heading: "Key Features of ICICI Bank Personal Loan EMI Calculator",

    tableContent: {
      heading: [
        {
          head: "Loan Type",
        },
        {
          head: "Interest Rate",
        },
        {
          head: "Loan Tenure",
        },
        {
          head: "Processing Fees",
        },
      ],
      row: [
        {
          type: "Personal Loan",
          interest: "10.50% to 19.00% p.a.",
          tenure: "12 months to 60 months",
          fee: "1% of loan amount (max ₹2,000)",
        },
      ],
    },
  },
];

export const stepThreeData = [
  {
    heading: "Factors Influencing Your EMI and Total Repayment",

    factorsList: [
      {
        heading: "Loan Amount: ",
        info: "A larger loan amount will result in a higher EMI unless you extend the tenure. Always ensure you borrow only what you need to avoid unnecessary financial strain.",
      },
      {
        heading: "Interest Rate: ",
        info: "Your interest rate will directly impact the EMI. A lower interest rate means a lower EMI and total interest paid over the term.",
      },
      {
        heading: "Loan Tenure: ",
        info: "A longer loan tenure results in a lower EMI but increases the overall interest burden. Shorter tenure results in higher EMIs but saves you money on interest.",
      },
      {
        heading: "Processing Fees: ",
        info: "ICICI Bank charges a processing fee of 1% of the loan amount (up to a maximum of ₹2,000), which is added to the loan amount.",
      },
    ],
  },
];

export const stepFourData = [
  {
    heading: "How Loan Tenure Affects EMI and Total Repayment",

    tableContent: {
      heading: [
        {
          head: "Loan Tenure",
        },
        {
          head: "Monthly EMI",
        },
        {
          head: "Total Interest",
        },
        {
          head: "Total Repayment",
        },
      ],
      row: [
        {
          tenure: "1 year",
          emi: "Higher EMI",
          interest: "Low Interest",
          repayment: "Lower Total Repayment",
        },
        {
          tenure: "2 years",
          emi: "Moderate EMI",
          interest: "Moderate Interest",
          repayment: "Moderate Total Repayment",
        },
        {
          tenure: "3 years",
          emi: "Lower EMI	",
          interest: "Higher Interest",
          repayment: "Higher Total Repayment",
        },
        {
          tenure: "5 years",
          emi: "Very Low EMI	",
          interest: "Much Higher Interest	",
          repayment: "Much Higher Total Repayment",
        },
      ],
    },

    infoList: [
      {
        head: "Shorter Tenure: ",
        info: "Results in higher EMI but lower total interest paid.",
      },
      {
        head: "Longer Tenure: ",
        info: "Results in lower EMI but increases the total interest paid over the loan's term.",
      },
    ],
  },
];

export const stepFiveData = [
  {
    heading: "Why You Should Consider APR Over Just Interest Rates",
    tip: "A slightly higher interest rate but lower processing fees could result in a lower APR, making the loan more affordable in the long run.",
  },
];

export const stepSixData = [
  {
    heading: "Understanding the Breakdown of Your ICICI Bank Personal Loan EMI",
    paraOne:
      "The EMI for an ICICI Bank Personal Loan is composed of two components:",
    infoList: [
      {
        head: "Principal Repayment: ",
        info: "The portion of the EMI that is used to repay the original loan amount.",
      },
      {
        head: "Interest Payment: ",
        info: "The cost of borrowing, calculated based on the outstanding balance of the loan.",
      },
    ],
    paraTwo:
      "In the early stages of the loan, most of the EMI goes toward paying interest. Over time, the interest portion decreases, and more of your EMI goes toward repaying the principal.",
  },
];

export const stepSevenData = [
  {
    heading: "Understanding the Breakdown of Your HDFC Bank Personal Loan EMI",
    paraOne:
      "Understanding how your EMI is calculated will help you manage your finances better. Knowing your EMI in advance ensures you’re prepared for the repayment and can budget accordingly.",
  },
];

export const stepEightData = [
  {
    heading: "MinEmi Tips for ICICI Bank Personal Loan Borrowing",
    infoList: [
      {
        head: "Check Your Credit Score: ",
        info: "A higher credit score can help you secure a lower interest rate. Before applying, make sure your credit score is in good shape.",
      },
      {
        head: "Choose an Appropriate Loan Amount: ",
        info: "Borrow only as much as you need. A higher loan amount means higher EMIs and more interest paid.",
      },
      {
        head: "Select a Suitable Tenure: ",
        info: "Opt for a tenure that suits your budget. While a longer tenure lowers your EMI, it increases the total interest paid over time.",
      },
      {
        head: "Prepayment Options: ",
        info: "ICICI Bank allows you to make prepayments, which can help reduce the principal outstanding, thereby reducing the EMI and interest burden over time.",
      },
    ],
  },
];
